"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _curry = _interopRequireDefault(require("curry"));
var _reactFlatten = _interopRequireDefault(require("./reactFlatten"));
var reactMap = (0, _curry.default)(function (fn, children) {
  var flattenedChildren = (0, _reactFlatten.default)(children);
  return _react.default.Children.map(flattenedChildren, function (child, i) {
    if (!child) return null;
    return fn(child, i, flattenedChildren);
  });
});
var _default = reactMap;
exports.default = _default;